export default __webpack_public_path__ + "static/media/Group 4933.e7db2507.png";